function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export default class PlanDetails {
  constructor(token, name, lowerPlanName, priceInCent, currencyCode, features, featureTooltips, freeTrialDaysLeft, renewalCycle) {
    _defineProperty(this, "token", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "lowerPlanName", void 0);
    _defineProperty(this, "priceInCent", void 0);
    _defineProperty(this, "currencyCode", void 0);
    _defineProperty(this, "features", void 0);
    _defineProperty(this, "featureTooltips", void 0);
    _defineProperty(this, "freeTrialDaysLeft", void 0);
    _defineProperty(this, "renewalCycle", void 0);
    _defineProperty(this, "isFree", void 0);
    this.token = token;
    this.name = name;
    this.lowerPlanName = lowerPlanName;
    this.priceInCent = priceInCent;
    this.currencyCode = currencyCode;
    this.features = features;
    this.featureTooltips = featureTooltips;
    this.freeTrialDaysLeft = freeTrialDaysLeft || 0;
    this.renewalCycle = renewalCycle;
    this.isFree = this.priceInCent === 0;
  }
}